<div class="wrapper">
  <div class="hour">{{hour}} <div class="seconds">:{{seconds}}</div></div>
</div>
